const isDebug = false;//注意：正式发布前请修改此值为false

//超级管理员，系统管理员(开发者)
const allowRoles = ["schoolAdmin"];//允许登录的角色KEY

//别名，解决多程序情况下本地存储、更新冲突的问题
const appAlias = 'aicp_school_materials';

const stateKeyName = appAlias + "_$state_"+appAlias;

const  tokenKeyName = appAlias + "_$tokenKeyName_"+appAlias;


//对应后台角色管理中:允许登录应用范围,21:代表会员移动
const use = 16;

export default{
	isDebug,

	allowRoles,
	appAlias,
	stateKeyName,
	tokenKeyName
}
